import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Member } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { memberQueryKeys } from "./keys";


export const useDeleteMember = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Member, AxiosError, string>({
        mutationKey: ["member", "delete", agentId],
        mutationFn: async (memberId: string) => {
            try {
                const { data } = await memberRepository.delete(agentId, memberId);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        retry: false,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: memberQueryKeys.all(agentId)
            });
        }
    });
};
